/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：754
 */

module.exports = {
  container: "ChromeTips_container__UrOSY",
  wrapper: "ChromeTips_wrapper__3rbFc",
  codemaoImg: "ChromeTips_codemaoImg__2bGYz",
  compatibility: "ChromeTips_compatibility__Yty34",
  chromeImg: "ChromeTips_chromeImg__2ygfX",
  close: "ChromeTips_close__3NM2r"
}
